export function getUserInitials(email: string) {
    console.log('email', email);
    return email
        .split('@')[0]
        .split('.')
        .map((word) => word[0])
        .join('')
        .toUpperCase();
}
